import React from 'react';

import styles from './styles.module.scss';
import DTMC from './images/dtmc.jpg';
import GrovePark from './images/grove-park-elementary.jpg';
import MiamiJackson from './images/miami-jackson-senior-high.png';
import OrangePark from './images/orange-park-elementary.png';
import Shenandoah from './images/shenandoah-middle.png';
import StStephens from './images/st-stephens-day-school.png';
import Tynes from './images/tynes-elementary.png';
import YWPA from './images/ywpa.jpg';

const partnerSchools = [
  { key: 'ywpa', icon: YWPA, label: "Young Women's Preparatory Academy" },
  {
    key: 'st-stephens',
    icon: StStephens,
    label: 'St. Stephens Episcopal Day School',
  },
  { key: 'dtmc', icon: DTMC, label: 'Downtown Miami Charter' },
  { key: 'orange-park', icon: OrangePark, label: 'Orange Park Jr. High' },
  { key: 'grove-park', icon: GrovePark, label: 'Grove Park Elementary' },
  { key: 'tynes', icon: Tynes, label: 'Tynes Elementary' },
  {
    key: 'miami-jackson',
    icon: MiamiJackson,
    label: 'Miami Jackson Senior High',
  },
  { key: 'shenandoah', icon: Shenandoah, label: 'Shenandoah Middle' },
];

const Partners = () => (
  <div className="d-flex flex-row flex-wrap align-items-center justify-content-around">
    {partnerSchools.map(school => (
      <div key={school.key} className={styles.partnerSchool}>
        <img src={school.icon} alt={`${school.label}'s logo`} />
        {school.label && <span>{school.label}</span>}
      </div>
    ))}
  </div>
);

export default Partners;
